import { Environment } from '@rxap/environment';

export const environment: Environment = {
  name: 'production',
  production: true,
  app: 'portal',
  serviceWorker: true,
  sentry: {
    dsn: 'https://28dda2634d7e445689ed1f27aadbdb77@sentry.eurogard.cloud/6',
    enabled: true,
    debug: false,
  },
  firebase: true,
};
